import {copy} from '../../../../../../util/fieldscopy'
import {FormSectionType} from '../../../../../blocks/FormBlock'

const privacy: FormSectionType = {
	id: 5,
	parent_id: 2,
	channel: 'section',
	label: copy?.privacy?.label || 'Privacy',
	fields: [
		{
			id: 1,
			parent_id: 5,
			channel: 'checkbox',
			name: 'privacy',
			label:
				copy?.privacy?.checkbox ||
				'Ik ga akkoord met de GDPR-richtlijnen zoals beschreven in de <a href="https://www.broederlijkdelen.be/nl/disclaimer-en-privacyverklaring" target="_blank">privacyverklaring</a>.',
			mod: 'maxwidth',
			required: true
		}
	]
}

export default privacy
